// Aktif magazanin dikeyi (vertical) ve buna bagli gorunurluk kurallari.
//
// Is modeli: ayni panelde farkli dikeylerde magazalar var. Takı magazasinda
// tekstil tasarimi/mockup'i, tekstil magazasinda da konsept fotograflari
// gorunmemeli — uretim mantiklari birbirinden tamamen farkli.
//
// Uretim hattina gore ayrim:
//   mockup_overlay (tekstil/hediyelik) → tasarim havuzu + bos mockup + alan
//   concept_photo  (taki)              → konsept fotograf + tedarikci urunu
//
// Katalog varyasyonu, liste sablonu ve beden tablosu her iki dikeyde de AYNI
// calisir; burada yalnizca gorsel uretim varliklari ayrilir.

import { useShopStore } from "../store/shop.store";

export type Vertical = "apparel" | "giftware" | "jewelry";

export function useShopVertical() {
  const { shops, activeShopId } = useShopStore();
  const shop = shops.find((s) => s.id === activeShopId) ?? shops.find((s) => s.isDefault) ?? shops[0];
  const vertical = (shop?.vertical ?? "apparel") as Vertical;

  // Taki: sahnedeki urun AI ile degistirilir; tasarim havuzu ve bos mockup
  // kavrami yoktur.
  const isConceptVertical = vertical === "jewelry";

  return {
    shop,
    vertical,
    platform: shop?.platform ?? "etsy",
    /** Gorsel uretimi konsept fotograf uzerinden mi yurur */
    isConceptVertical,
    /** Tasarim havuzu / Design Builder / Mockup Studio bu magazada anlamli mi */
    usesDesignPool: !isConceptVertical,
    /** /api/mockups icin kind filtresi */
    mockupKind: isConceptVertical ? ("concept" as const) : ("mockup" as const),
  };
}
